import { splitTextHTML } from '../../../../utils/lookahead-common';

const RESPONSIBLE_AVATAR_WIDTH = 16;

export const renderSelectedOption = (responsibles, column) => {
  if (!responsibles || !responsibles.length) {
    return `<div class="empty-selection">
        <div class="plus-icon-container"></div>
      </div>`;
  }

  const width = column?.width || 0;
  const totalWidthResponsables = responsibles.length * RESPONSIBLE_AVATAR_WIDTH;
  let applyPlusCounter = false;
  let maxElPerWidth = 0;
  let restElements = 0;

  if (totalWidthResponsables > width) {
    applyPlusCounter = true;
    maxElPerWidth = Math.floor(width / RESPONSIBLE_AVATAR_WIDTH);
  }

  const adjustPlus = 2;

  let responsibleHtml = '';

  responsibles.forEach((responsible, index) => {
    if (
      applyPlusCounter &&
      maxElPerWidth &&
      index > maxElPerWidth - adjustPlus
    ) {
      restElements++;
      return;
    }

    const image = responsible.image;
    const initials = `${responsible.name ? responsible.name[0] : ''}${responsible.lastname ? responsible.lastname[0] : ''}`;
    const fullName =
      `${responsible.name || ''} ${responsible.lastname || ''}`.trim();

    responsibleHtml += `
      <span class="solapate-responsable-gantt" title="${fullName}">
        ${
          image
            ? `<img class="img-responsable-lookahead" src="${image}" alt="${fullName}" />`
            : `<div class="img-responsable-lookahead no-img">${initials}</div>`
        }
      </span>
    `;
  });

  if (applyPlusCounter && restElements > 0) {
    responsibleHtml += `<div class="plus-counter-responsable-gantt">+${restElements}</div>`;
  }

  return responsibleHtml;
};

export const createPlaceholderHtml = (
  columnName,
  taskId,
  selectedResponsibles,
  column
) => `
    <div id="responsible-placeholder-${columnName}-${taskId}" class="placeholder-container">
      ${renderSelectedOption(selectedResponsibles, column)}
    </div>
  `;

export const createOptionsListHtml = (
  optionsList,
  selectedResponsible = [],
  column
) => {
  if (!optionsList || !optionsList.length) return '';

  const selectedIds = selectedResponsible.map((resp) => String(resp.id));

  return optionsList
    .map((option) => {
      const isSelected = selectedIds.includes(String(option.id));
      const optionData = JSON.stringify(option).replace(/"/g, '&quot;');
      const name = `${option.name || ''} ${option.lastname || ''}`.trim();
      const image = option.image || '';

      return `
      <li class="dropdown-option ${isSelected ? 'selected-option' : ''}">
        <div 
          class="dropdown-item"
          data-action="responsibleSelection"
          data-value="${optionData}">
          <div class="option-content" style="width: ${column.width}px;">
            <div class="responsible-avatar">
              ${
                image
                  ? `<img src="${image}" alt="${name}" width="${RESPONSIBLE_AVATAR_WIDTH}" height="${RESPONSIBLE_AVATAR_WIDTH}" style="border-radius: 50%;" />`
                  : `<div class="img-responsable-lookahead no-img" style="width: 16px; height: 16px; font-size: 8px;">${option.name ? option.name[0] : ''}${option.lastname ? option.lastname[0] : ''}</div>`
              }
            </div>
            <span class="option-text">${splitTextHTML(name, column.width)}</span>
          </div>
        </div>
      </li>
    `;
    })
    .join('');
};
